import { Box, Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { observer } from 'mobx-react';
import { LoanAgreementCoverPage } from './loanAggrementComponents/loanAggrementCoverPage';
import { LoanAgreementContentPage } from './loanAggrementComponents/loanAgreementContentPage';
import { SignatureFieldHandle } from '@roc/ui';
import { useRef } from 'react';
import GestureIcon from '@material-ui/icons/Gesture';
import BorderColorIcon from '@material-ui/icons/BorderColor';
import { useStore } from '@roc/client-portal-shared/hooks';

const useStyles = makeStyles(theme => ({
  container: {
    maxWidth: 1300,
    margin: 'auto',
    padding: theme.spacing(3),
    position: 'relative',
  },
  scrollButton: {
    position: 'fixed',
    bottom: theme.spacing(4),
    right: theme.spacing(4),
    zIndex: 1300,
    backgroundColor: theme.palette.primary.main,
    color: '#fff',
    borderRadius: theme.spacing(1),
    padding: theme.spacing(1.5, 3),
    boxShadow: '0 3px 6px rgba(0,0,0,0.2)',
    '&:hover': {
      backgroundColor: theme.palette.primary.dark,
    },
  },
}));

export const MersDocumentSigning = observer(({ signatureRef, store }) => {
  const classes = useStyles();
  const { companyProfileStore } = useStore();
  const { lenderDetailsStore } = companyProfileStore;
  const { salesforceLenderStore, } = lenderDetailsStore;
  const fromValues = store.getFormValues();

  const handleScrollToSignature = () => {
    signatureRef.current?.scrollTo();
  };

  return (
    <Box className={classes.container}>
      <Box mb={6}>
        <LoanAgreementCoverPage lender={salesforceLenderStore.salesForceLender} />
      </Box>
      <LoanAgreementContentPage signatureRef={signatureRef} lender={salesforceLenderStore.salesForceLender} fromValues={fromValues} />
      <Button
        variant="contained"
        startIcon={<BorderColorIcon />}
        className={classes.scrollButton}
        onClick={handleScrollToSignature}
      >
        Go to Signature
      </Button>
    </Box>
  );
});